interface ProductImageOrderingApiResponse {
  productNumber: String;
  quantityCases: Number;
  quantityEaches: Number;
}

export interface ImageOrderingResult {
  imageId: string;
  matches: Matches[];
  fileName?: string;
  fileType?: string;
}
interface Matches {
  productNumber: string;
  productDescription: string;
  quantityCases: number;
  quantityEaches: number;
  matchedProductNumber: string;
}

export interface ImageOrderingApiResponse {
  productsRequestedCount?: number;
  productsNotFoundCount?: number;
  suggestions?: ProductImageOrderingApiResponse[];
  error?: boolean;
  matches?: Matches[];
}

export enum SortColumn {
  ROW_NUMBER = 'rowNumber',
  PRODUCT_NUMBER = 'productNumber',
  PRODUCT_NAME = 'productName',
  DETECTED_QUANTITY = 'detectedQuantity',
  QUANTITY_TYPE = 'quantityType',
  MATCH = 'matchDescription',
}

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
  NONE = 'none',
}

export const mockImageOrderingApiResponse: ImageOrderingApiResponse = {
  productsRequestedCount: 2,
  suggestions: [
    {
      productNumber: '1579327',
      quantityEaches: 0,
      quantityCases: 20,
    },
    {
      productNumber: '9341587',
      quantityEaches: 0,
      quantityCases: 30,
    },
  ],
  productsNotFoundCount: 0,
  error: false,
  matches: [
    {
      productNumber: '1579327',
      productDescription: 'Water, Purified Plastic Bottle Variable',
      quantityCases: 5,
      quantityEaches: 0,
      matchedProductNumber: '1579327',
    },
    {
      productNumber: '620559',
      productDescription: '',
      quantityCases: 20,
      quantityEaches: 0,
      matchedProductNumber: '620559',
    },
    {
      productNumber: '',
      productDescription: 'TORTILLA, CORN WHITE 6" DIE CUT SHELF STABLE',
      quantityCases: 20,
      quantityEaches: 0,
      matchedProductNumber: '',
    },
    {
      productNumber: '',
      productDescription:
        'JUICE BASE, APPLE 100% 5:1 DISPENSER CARTRIDGE FROZEN',
      quantityCases: 9,
      quantityEaches: 0,
      matchedProductNumber: '9341587',
    },
    {
      productNumber: '8785610',
      productDescription:
        'PIZZA, SAUSAGE & PEPPERONI 12" THIN CRUST FROZEN LOTZZA MOTZZA',
      quantityCases: 10,
      quantityEaches: 0,
      matchedProductNumber: '8785610',
    },
    {
      productNumber: '',
      productDescription:
        'SPICE, PEPPER RED CRUSHED PLASTIC SHAKER SHELF STABLE SEASONING',
      quantityCases: 5,
      quantityEaches: 0,
      matchedProductNumber: '',
    },
    {
      productNumber: '958157',
      productDescription:
        'Garlic, White Whole Clove Peeled Plastic Jar Fresh Ref',
      quantityCases: 0,
      quantityEaches: 10,
      matchedProductNumber: '958157',
    },
    {
      productNumber: '9168188',
      productDescription: 'SOUP, CHICKEN TORTILLA CHEESE RTU BAG FROZEN',
      quantityCases: 0,
      quantityEaches: 10,
      matchedProductNumber: '',
    },
  ],
};
